export const EMAIL_FIELD = {
  FROM_NAME: 'FROM_NAME',
  CUSTOM_REPLY_TO: 'CUSTOM_REPLY_TO',
  REPLY_TO: 'REPLY_TO',
  SUBJECT: 'SUBJECT',
  CUSTOM_REPLY_TO_ENABLED: 'CUSTOM_REPLY_TO_ENABLED',
  PREVIEW_TEXT: 'PREVIEW_TEXT',
  HTML_TITLE: 'HTML_TITLE',
  MAILING_LISTS_INCLUDED: 'MAILING_LISTS_INCLUDED',
  MAILING_LISTS_EXCLUDED: 'MAILING_LISTS_EXCLUDED',
  VIDS_INCLUDED: 'VIDS_INCLUDED',
  VIDS_EXCLUDED: 'VIDS_EXCLUDED',
  RSS_TO_EMAIL_TIMING: 'RSS_TO_EMAIL_TIMING',
  PUBLISH_DATE: 'PUBLISH_DATE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  PREFERENCES_GROUP_ID: 'PREFERENCES_GROUP_ID',
  SLUG: 'SLUG',
  PAGE_EXPIRY_DATE: 'PAGE_EXPIRY_DATE',
  PAGE_EXPIRY_REDIRECT_ID: 'PAGE_EXPIRY_REDIRECT_ID',
  SMART_CONTENT_LISTS: 'SMART_CONTENT_LISTS',
  MASKED_REPLY_TO: 'MASKED_REPLY_TO',
  WIDGETS: 'WIDGETS',
  USE_RSS_HEADLINE_AS_SUBJECT: 'USE_RSS_HEADLINE_AS_SUBJECT',
  DOMAIN: 'DOMAIN',
  RESOLVED_DOMAIN: 'RESOLVED_DOMAIN',
  CREATE_PAGE: 'CREATE_PAGE',
  RSS_EMAIL_ENTRY_TEMPLATE: 'RSS_EMAIL_ENTRY_TEMPLATE',
  STYLE_SETTINGS: 'STYLE_SETTINGS',
  TEMPLATE_PATH: 'TEMPLATE_PATH',
  EMAILBODY_PLAINTEXT: 'EMAILBODY_PLAINTEXT',
  STATE: 'STATE',
  SUBCATEGORY: 'SUBCATEGORY',
  PUBLISH_IMMEDIATELY: 'PUBLISH_IMMEDIATELY',
  CAMPAIGN: 'CAMPAIGN',
  CAMPAIGN_NAME: 'CAMPAIGN_NAME',
  CAMPAIGN_UTM: 'CAMPAIGN_UTM'
};
// Mirror of:  https://git.hubteam.com/HubSpot/marketing-email-service-types/blob/27882e29394db1aaca063bb4078f42e03ed7e13a/marketing-email-service-types/static-1.940/js/COSEmailService/types.ts#L2004
export const EMAIL_TYPE = Object.freeze({
  AB_EMAIL: 'AB_EMAIL',
  AUTOMATED_AB_EMAIL: 'AUTOMATED_AB_EMAIL',
  AUTOMATED_EMAIL: 'AUTOMATED_EMAIL',
  BATCH_EMAIL: 'BATCH_EMAIL',
  BLOG_EMAIL: 'BLOG_EMAIL',
  BLOG_EMAIL_CHILD: 'BLOG_EMAIL_CHILD',
  FEEDBACK_CES_EMAIL: 'FEEDBACK_CES_EMAIL',
  FEEDBACK_CUSTOM_EMAIL: 'FEEDBACK_CUSTOM_EMAIL',
  FEEDBACK_CUSTOM_SURVEY_EMAIL: 'FEEDBACK_CUSTOM_SURVEY_EMAIL',
  FEEDBACK_NPS_EMAIL: 'FEEDBACK_NPS_EMAIL',
  FOLLOWUP_EMAIL: 'FOLLOWUP_EMAIL',
  LEADFLOW_EMAIL: 'LEADFLOW_EMAIL',
  LOCALTIME_EMAIL: 'LOCALTIME_EMAIL',
  MARKETING_SINGLE_SEND_API: 'MARKETING_SINGLE_SEND_API',
  MEMBERSHIP_EMAIL_VERIFICATION_EMAIL: 'MEMBERSHIP_EMAIL_VERIFICATION_EMAIL',
  MEMBERSHIP_FOLLOW_UP_EMAIL: 'MEMBERSHIP_FOLLOW_UP_EMAIL',
  MEMBERSHIP_OTP_LOGIN_EMAIL: 'MEMBERSHIP_OTP_LOGIN_EMAIL',
  MEMBERSHIP_PASSWORDLESS_AUTH_EMAIL: 'MEMBERSHIP_PASSWORDLESS_AUTH_EMAIL',
  MEMBERSHIP_PASSWORD_RESET_EMAIL: 'MEMBERSHIP_PASSWORD_RESET_EMAIL',
  MEMBERSHIP_PASSWORD_SAVED_EMAIL: 'MEMBERSHIP_PASSWORD_SAVED_EMAIL',
  MEMBERSHIP_REGISTRATION_EMAIL: 'MEMBERSHIP_REGISTRATION_EMAIL',
  MEMBERSHIP_REGISTRATION_FOLLOW_UP_EMAIL: 'MEMBERSHIP_REGISTRATION_FOLLOW_UP_EMAIL',
  MEMBERSHIP_VERIFICATION_EMAIL: 'MEMBERSHIP_VERIFICATION_EMAIL',
  OPTIN_EMAIL: 'OPTIN_EMAIL',
  OPTIN_FOLLOWUP_EMAIL: 'OPTIN_FOLLOWUP_EMAIL',
  RESUBSCRIBE_EMAIL: 'RESUBSCRIBE_EMAIL',
  RSS_EMAIL: 'RSS_EMAIL',
  RSS_EMAIL_CHILD: 'RSS_EMAIL_CHILD',
  SINGLE_SEND_API: 'SINGLE_SEND_API',
  SMTP_TOKEN: 'SMTP_TOKEN',
  TICKET_EMAIL: 'TICKET_EMAIL'
});

// Email types from here https://git.hubteam.com/HubSpot/content4j/blob/master/ContentModel/src/main/java/com/hubspot/content/model/SubCategory.java#L15
// along with ab/automated ab